import React, { Component } from 'react';
import config from './../../../../config';
import RenderSVGToCanvas, { RenderImageToCanvas } from '../../../../helpers/RenderToCanvas';
import DownloadCanvas from '../../../../helpers/DownloadCanvas';
import {
  ChartActionsContainer,
  ChartForm,
  ChartInput,
  ChartTextArea,
  ChartDownloadButtonImage,
  ChartCanvasLink,
} from './ChartActions.styled';
import { PopperTooltip } from '@emarketer/componentlibrary';

interface IChartActionsProps {
  id: string;
  collectionId: string;
  name: string;
  chartType: string;
  allowExport: boolean;
}

export default class ChartActions extends Component<IChartActionsProps, {}> {
  handleSubmit = (e) => {
    e.preventDefault();
    return false;
  };

  public render() {
    const { id, name, allowExport, chartType, collectionId } = this.props;

    const downloadExcel = () => {
      window.location.assign(`${config.apiHost}/exporttemplatecsv/${id}?collectionId=${collectionId}`);
    };

    const downloadPng = () => {
      const selector = document.getElementById('HCDIV');
      const isHighchart = chartType !== 'horizontalBar';
      const height = isHighchart ? selector.scrollHeight.valueOf() : selector.offsetHeight;
      const width = isHighchart ? selector.scrollWidth.valueOf() : selector.offsetWidth;
      const svgElem = selector.getElementsByTagName('svg')[0];
      const options = { height, width };

      /*
          This is a work-around to avoid graphical defect that consistently appears the first time a chart is downloaded.
          The cause is yet unknown, but generating the image and discarding the initial result circumvents the issue.
          */
      if (svgElem) {
        RenderSVGToCanvas(svgElem, options, isHighchart, (canvas: HTMLCanvasElement, svg: string) => {
          // this rerenders the canvas to another larger canvas with a
          // white background to create the apperance of a white border:
          RenderImageToCanvas(canvas.toDataURL('image/png'), options, isHighchart, (canvas) => {
            // download the final canvas as png
            DownloadCanvas(canvas, name + '.png', 'image/png');
          });
        });
      } else {
        return null;
      }
    };

    return (
      <ChartActionsContainer flexDirection="row" spaceBetween={8}>
        <PopperTooltip
          controlShow={false}
          showArrow
          hideBoxShadow
          placement="bottom-end"
          distance={10}
          target={
            <ChartDownloadButtonImage
              data-analytics="Export-Image"
              width="31"
              height="37"
              onClick={() => {
                if (allowExport) downloadPng();
              }}
              $disabledButton={!allowExport}
            >
              <use xlinkHref={`#widget-file-png`} />
            </ChartDownloadButtonImage>
          }
        >
          <div className="png">Export Chart Image</div>
        </PopperTooltip>
        <PopperTooltip
          controlShow={false}
          showArrow
          hideBoxShadow
          placement="bottom-end"
          distance={10}
          target={
            <ChartDownloadButtonImage
              data-analytics="Export-Excel"
              width="31"
              height="37"
              onClick={downloadExcel}
              $disabledButton={false}
            >
              <use xlinkHref={`#widget-file-xls`} />
            </ChartDownloadButtonImage>
          }
        >
          <div className="xls">Export To Excel</div>
        </PopperTooltip>
        {/* <IconPanel
               authenticated={true} // pod !== 'NAX' && this.authCookie
               isMobile={false}
            /> */}
        <ChartCanvasLink id="canvas-click" href="#" />
        <ChartForm
          onSubmit={this.handleSubmit}
          id="chart-download"
          action={config.apiHost + '/exportimage'}
          method="POST"
          style={{ display: 'none' }}
        >
          <ChartInput type="text" id="chart-download-title" name="title" />
          <ChartTextArea id="chart-download-data" name="ChartData" />
        </ChartForm>
        {/* <DownloadIcons /> until we figure out a public version of these, should be hidden*/}
      </ChartActionsContainer>
    );
  }
}
